import React from 'react'
import { Button as ButtonEx } from '@shared/components/button'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import { IProcessList } from '@shared/components/sections/process/data'
import { Button } from '@shared/componentsStyled/Button'
import { useSelectDevice } from '@shared/hooks/use-select-device'
import cx from 'classnames'
import styled from 'styled-components'

import { data } from './data'
import { Point } from './Point'

import styles from './style.module.scss'

export interface SectionProcessProps {
	boxClassname?: string
	onButtonClick(): void
	title: JSX.Element | string
	subtitle?: JSX.Element | string
	points?: IProcessList[]
}

export const Process = ({
	boxClassname,
	onButtonClick,
	title,
	subtitle,
	points,
}: SectionProcessProps): JSX.Element => {
	return (
		<Section>
			<ViewRoot>
				<ViewColImage>
					<ImagePassport
						// lazy
						name={useSelectDevice({
							mobile: 'passport.png',
							// tablet: 'passport.png',
							default: 'passport-desktop.png',
						})}
						className={styles.passportImg}
					/>
					<ViewImageContent>
						<TextHeader>{title}</TextHeader>
						{subtitle && <TextSubHeader>{subtitle}</TextSubHeader>}
						<div>
							<Button onClick={onButtonClick}>Оставить заявку</Button>
						</div>
					</ViewImageContent>
				</ViewColImage>
				<ViewColList>
					<ListPoints>
						{(points || data).map((point, idx) => (
							<Point key={idx} point={point} idx={idx} />
						))}
					</ListPoints>
				</ViewColList>
			</ViewRoot>
		</Section>
	)
}

// REF_MEDIA
const ViewRoot = styled.div(({ theme }) => ({
	display: 'flex',
	flex: 1,
	marginBottom: 120,
	flexDirection: 'column',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginBottom: 60,
	},
	[theme.mediaQueries.mediaMinWidthTablet]: {
		flexDirection: 'row',
	},
	[theme.mediaQueries.mediaMinWidthDesktop]: {
		marginBottom: 120,
	},
}))

const ViewColImage = styled.div(({ theme }) => ({
	flex: 1,
	backgroundColor: theme.colors.greenlight,
	position: 'relative',
	overflow: 'hidden',
	textShadow: `0 0 10px ${theme.colors.greenlight}`,
	display: 'flex',
	flexDirection: 'column',
	padding: 20,
	borderRadius: '8px 8px 0 0',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		padding: '40px 20px',
	},
	[theme.mediaQueries.mediaMinWidthTablet]: {
		padding: 40,
		borderRadius: '8px 0 0 8px',
	},
}))

const ViewColList = styled.div(({ theme }) => ({
	border: '2px solid',
	borderColor: theme.colors.border,
	flex: 1,
	borderRadius: '0 0 8px 8px',
	padding: 20,
	[theme.mediaQueries.mediaMinWidthTablet]: {
		borderRadius: '0 8px 8px 0',
		padding: '40px 32px',
	},
}))

const ImagePassport = styled(Image)(({ theme }) => ({
	position: 'absolute',
	bottom: 0,
	right: 0,
}))

const TextHeader = styled.h2(({ theme }) => ({
	...theme.typography.header24_28,
	marginBottom: 40,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.header40_44,
	},
}))

const TextSubHeader = styled.h3(({ theme }) => ({
	...theme.typography.header20_24,
	marginBottom: 40,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.header28_32,
	},
}))

const ViewImageContent = styled.div(({ theme }) => ({
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-between',
	position: 'relative',
	maxWidth: '70%',
	[theme.mediaQueries.mediaMinWidthTablet]: {
		maxWidth: '100%',
	},
}))

const ListPoints = styled.ul(({ theme }) => ({}))

export const ProcessEx = ({
	boxClassname,
	onButtonClick,
	title,
	subtitle,
	points,
}: SectionProcessProps) => {
	return (
		<Section className={styles.content}>
			<div className={cx(styles.backgroundBox, boxClassname)}>
				<div className={styles.backgroundBoxContent}>
					<div>
						<h2 className={styles.h2}>{title}</h2>
						{subtitle && (
							<div className='mt-s mb-s'>
								<h4>{subtitle}</h4>
							</div>
						)}
					</div>
					<ButtonEx className={styles.button} onClick={onButtonClick}>
						Оставить заявку
					</ButtonEx>
				</div>
				<Image
					lazy
					name={useSelectDevice({
						mobile: 'passport.png',
						tablet: 'passport.png',
						default: 'passport-desktop.png',
					})}
					className={styles.passportImg}
				/>
			</div>
			<ul className={styles.processList}>
				{(points || data).map(({ title, text }, index) => (
					<li className={styles.processItem} key={index}>
						<div className={styles.processCount}>{index + 1}</div>
						<h4 className={styles.h4}>{title}</h4>
						<p className={styles.processText}>{text}</p>
					</li>
				))}
			</ul>
		</Section>
	)
}
